import { atom } from "recoil";

const themeAppStore = atom<string | null>({
	key: "themeAppStore",
	default: localStorage.getItem("theme"),
});

export default themeAppStore;
